import { useGetOrganizationQuery } from '../queries/useGetOrganizationQuery'

/** 'SPOT' is Sanofi's legacy pre-rebrand platform name -- the org-agnostic way to identify them. */
const SANOFI_PLATFORM_NAME = 'SPOT'

export const useIsSanofiOrganization = () => {
    const { data: organization } = useGetOrganizationQuery()

    return organization?.platformName === SANOFI_PLATFORM_NAME
}
